<template>
  <div class="coupon-detail">
    <div v-if="isInit">
      <header v-if="productInfo.image">
        <img class="activity-bg" v-lazy="lazyImgObj(productInfo.image)" alt="">
      </header>
      <main>
        <div class="content">
          <div class="main-left">
            <p class="text-explain">{{productInfo.valueDesc}}</p>
            <p class="activity-rule">{{productInfo.benefitDesc}}</p>
          </div>
          <div class="main-right">
            <p class="text-explain" v-if="productInfo.priceSplit">{{productInfo.priceSplit.display}}</p>
            <p  class="text-del" v-if="productInfo.displayPriceSplit">
              {{productInfo.displayPriceSplit.display}}
            </p>
          </div>
        </div> 
         <!-- 购买按钮 -->
        <rich-button 
          v-show="isBuy"
          class="buy-btn"
          @click="handelSubmit" 
        >
          {{gettext('支付')}}
        </rich-button>
      </main>
      <footer>
        <SpiltLine :title="gettext('条款和条件')"></SpiltLine>
        <div class="rule-description">
          <p v-for="(item,index) in ruleDescriptionList" :key="index">
            {{item}}
          </p>
        </div>
      </footer>
    </div>
    <LoadingMask v-show="loading"></LoadingMask>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import LoadingMask from '@/components/loading/loading-mask'
import SpiltLine from '@/components/split-line'
import getCountryConfig from '@/common/config/country-config'

export default {
  name: 'detail',
  data () {
    return {
      productInfo: {},
      loading: false,
      isInit: false
    }
  },
  components: {
    SpiltLine,
    LoadingMask
  },
  computed: {
    ...mapGetters(['globalParams']),
    // 品牌名
    brand () {
      return this.$store.state.brand
    },
    country () {
      return this.$store.state.country
    },
    ruleDescriptionList () {
      return this.productInfo.ruleDescription ? this.productInfo.ruleDescription.split('\n') : []
    },
    isBuy () {
      return +this.$route.query.isBuy === 1 && +this.productInfo.canPurchase === 1
    }
  },
  async created () {
    this.pageInit()
  },
  methods: {
    ...mapActions({
      getProductList: 'getProductList',
      getGlobalInfo: 'getGlobalInfo'
    }),
    pageInit () {
      // 获取公参
      this.getGlobalInfo().then((data) => {
        this.fetchActivityInfo(data)
      })
    },
    async fetchActivityInfo (data) {
      this.loading = true
      const res = await this.getProductList({
        ...data,
        shopId: this.params.shopId || 0
      })
      this.loading = false
      this.isInit = true
      if (res && res.errno === 0) {
        if (Object.keys(res.data).length > 0) {
          // 权益活动为list格式，但是本期只会有一个活动。所以只取第一项
          this.productInfo = res.data.productList && res.data.productList.length > 0 && res.data.productList[0]
        } else {
          const toast = this.$createToast({
            txt: this.gettext('当前无活动'),
            time: 2000,
            type: 'error',
            mask: false
          })
          toast.show()
        }
      } else {
        const errorToast = this.$createToast({
          txt: (res && res.errmsg) || this.gettext('网络繁忙，请稍后再试'),
          time: 2000,
          mask: false,
          type: 'error'
        })
        errorToast.show()
      }
    },
    // 图片懒加载配置
    lazyImgObj (value) {
      return {
        src: value,
        error: `${getCountryConfig.brandBg.PLACEHOLDER_BG[this.brand]['C_COUPON_PLACEHOLDER']}`,
        loading: `${getCountryConfig.brandBg.PLACEHOLDER_BG[this.brand]['C_COUPON_PLACEHOLDER']}`
      }
    },
    handelSubmit () {
      this.$router.push({
        path: `/c/coupon/buy`,
        query: {
          productId: this.productInfo.productId,
          price: this.productInfo.price,
          priceDisplay: this.productInfo.priceSplit && this.productInfo.priceSplit.display
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~@/common/stylus/variables'
@import "~@/common/stylus/main"

.buy-btn{
  margin: 80px 0 20px 0;
}
.coupon-detail {
  background: #fff;
  height: 100%;
  header {
    height: 430px;
    .activity-bg {
      width: 100%;
    }
  }
  main {
    padding: 60px 40px 88px 40px;
    .content{
      display flex;
      .main-left{
        flex:1
      }
      .main-right{
        margin-left 60px
        text-align right
        .text-del{
          font-family: 'Aspira Regular';
          font-size: 24px;
          text-decoration: line-through;
          color: #999999;
          line-height 36px
          margin-bottom 10px
        }
      }
    }
    .title {
      width: 70%;
      margin: 0 auto;
      text-align: center;
      font-size: 46px;
      font-weight: 900;
      color: #F04E98;
      word-break: normal;
    }
    .text-explain {
      font-family: 'Aspira Medium';
      font-size:48px;
      color: #000000;
      letter-spacing: 0;
      line-height: 56px;
      margin-bottom 24px;
    }
    .text-price{
      font-family: 'Aspira Medium';
      font-size: 34px;
      line-height:48px;
    }
    .activity-rule {
      font-family: 'Aspira Regular';
      font-size: 28px;
      color: #333333;
      text-align: left;
      line-height 36px
      margin-bottom 10px
    }
    .activity-rule-bottom{
      width calc(100% - 230px)
    }
  }
  footer {
    padding: 0 40px;
    .rule-list {
      margin-top: 28px;
      .item {
        padding: 12px 0;
        font-family: 'Aspira Regular';
        font-size: 24px;
        color: #666666;
        text-align: left;
        line-height: 28px;
      }
    }
  }
  .rule-description{
    font-family: 'Aspira Regular';
    margin-top: 28px;
    font-size: 24px;
    line-height 40px;
    color: #666666;
    padding-bottom 50px
    p{
      padding-bottom 10px
    }
  }
}
</style>
